<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.account_team"
        :filters.sync="filters"
        @apply="reload"
        @ready="load"
      />

      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <AccountTeamsTable :teams="teams">
          <template v-slot:actions="{ team }">
            <el-dropdown
              split-button
              size="mini"
              type="primary"
              class="mr-2"
              trigger="click"
              @click="handleImpersonationOpen360(team)"
            >
              Impersonate
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleImpersonation(team)">
                  Impersonate OpenFreight
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </AccountTeamsTable>

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="teams.page"
          :page-size.sync="teams.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="teams.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Complex'
import AccountTeamsTable from '@/components/Application/CustomerService/Accounts/Account/Teams/Table'

export default {
  components: {
    Filters,
    AccountTeamsTable
  },
  data () {
    return {
      breadcrumb: {
        name: 'Teams',
        route: { name: 'customerservice-accounts-account-teams', params: { accountId: this.$route.params.accountId } }
      },
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoading: true,
      teams: [],
      filters: []
    }
  },
  methods: {
    load () {
      this
        .$sdk
        .account_team
        .list(request => {
          request.context = { resource: 'account', identifier: this.$route.params.accountId }
          request.filters = this.filters
        })
        .then(teams => { this.teams = teams })
        .finally(() => { this.isLoading = false })
    },
    async reload () {
      this.isLoading = true

      await this.teams.reload(request => { request.filters = this.filters })

      this.isLoading = false
    },
    async handleImpersonationOpen360 (team) {
      // Request an impersonation token for the team, which will be used by Open360 to authenticate the user
      await this.$sdk.account_team.impersonate(
        team.account.slug,
        (await this.$session.instance).tenancy.id,
        () => {
          this.$message.success('Impersonation Token Generated. Redirecting to Open360...')
        }
      )
    },
    async handleImpersonation (team) {
      window
        .open(
          this
            .$router
            .resolve({
              name: 'legacy-handover',
              query: {
                tenancy: (await this.$session.instance).tenancy.id,
                token: await this.$session.token,
                'impersonation-token': team.legacy.hash
              }
            })
            .href,
          '_blank'
        )
    }
  }
}
</script>
